import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch, Redirect, Router } from 'react-router-dom';
import { Welcome, Newsletter, RegisterSuccess, ResetPasswordSuccess } from './';
import {
  SignInContainer,
  SignOutContainer,
  EventsContainer,
  EventContainer,
  RegisterContainer,
  ResponseContainer,
  ResetPasswordContainer,
  DashboardContainer,
  HostContainer,
} from '../containers';
import { Header, Main } from '../styles/style';
import PrivateRoute from '../helpers/privateRoute';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import Loading from './Loading'
import styled from 'styled-components'

const Events = Loadable({
  loader: () => import('./admin/Events'),
  loading: Loading,
  delay: 300,
})

const Users = Loadable({
  loader: () => import('./admin/Users'),
  loading: Loading,
  delay: 300,
})

const Warning = styled.div`
  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 100%;
  background-color: red;
  color: white;
  text-align: center;
  padding: 8px 0px;
`

class App extends Component {

  componentWillMount() {
    if (localStorage.getItem('auth_token')) {
      this.props.loadUserFromToken();
    }
    document.body.className = window.location.pathname.replace(/\//g, '-').slice(1)
  }

  render() {
    const { store, currentUser, userLoading, history } = this.props;

    const oldBrowser = window.IE9_OR_OLDER || navigator.userAgent.indexOf('MSIE') > -1 || navigator.appVersion.indexOf('Trident/') > -1

    return (
      <Provider store={store}>
        <div className="App">
          {oldBrowser && <Warning className="browser-alert">You're using an older browser that we no longer support. For a better experience, update your browser.</Warning>}
          <Router history={history}>
            <Switch>
              <Route exact path="/host/welcome" component={Welcome} />
              <Route exact path="/host/register" component={RegisterContainer} />
              <Route exact path="/host/register-success" component={RegisterSuccess} />
              <Route exact path="/host/signin/:logintoken?" component={SignInContainer} />
              <Route exact path="/host/reset-password" component={ResetPasswordContainer} />
              <Route exact path="/host/reset-password-success" component={ResetPasswordSuccess} />
              <Route exact path="/host/newsletter" component={Newsletter} />
              <Route exact path="/host/signout" component={SignOutContainer} />
              <Route exact path="/event/:token" component={ResponseContainer} />

              <PrivateRoute path="/host/hub" component={HostContainer} currentUser={currentUser} userLoading={userLoading} />

              <PrivateRoute exact path="/host/admin/events" component={Events} adminRoute={true} currentUser={currentUser} userLoading={userLoading} />
              <PrivateRoute exact path="/host/admin/users" component={Users} adminRoute={true} currentUser={currentUser} userLoading={userLoading} />

              <Redirect to="/host/welcome" />
            </Switch>
          </Router>
        </div>
      </Provider>
    );
  }
}

export default App
